<template>
  <span
    :class="$style.badgeInfo"
  >
    <Icon
      :class="$style.infoIcon"
      icon="premiumDiscover"
      :scale="1.25"
    />
    <span>
      {{ textContent }}
      <span
        v-if="showLearnMoreLink"
        :class="$style.premiumFeatureUsageLinkText"
        data-test-id="learnMoreLink"
        @click="handleClick"
      >
        Learn More
      </span>
    </span>
  </span>
</template>

<script>

import { Icon } from '@jumpcloud/ui-components';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import moment from 'moment';

export default {
  name: 'PremiumFeatureBadge',
  components: {
    Icon,
  },
  props: {
    badgeTextBase: {
      type: String,
      default: () => 'You have been using this feature for',
    },
    customText: {
      type: String,
      default: () => '',
    },
    modalProps: {
      type: Object,
      default: () => {},
    },
    showLearnMoreLink: {
      type: Boolean,
      default: () => true,
    },
    trialStart: {
      type: String,
      default: null,
    },
  },

  computed: {
    textContent() {
      if (this.customText) return this.customText;

      const currentDate = moment();
      const timeSinceDays = currentDate.diff(moment(this.trialStart), 'days') + 1; // +1 because we don't want to show 0 days on day 1
      const daysText = timeSinceDays > 1 ? 'days' : 'day';
      const textContent = `${this.badgeTextBase} ${timeSinceDays} ${daysText}.`;
      return textContent;
    },
  },

  methods: {
    handleClick() {
      ModalEventBus.open({
        component: 'TrialModal',
        componentProps: { ...this.modalProps, showWelcomeMessage: false },
        isLargeModal: true,
      });

      this.$emit('click');
    },
  },
};

</script>

<style scoped module>
.badgeInfo {
  align-items: center;
  background: var(--badge-background, var(--jc-color-disabled-fill));
  background-color: var(--jcTertiary50);
  border-radius: var(--jc-border-radius-small);
  color: var(--jc-text-color-dark);
  display: flex;
  font-size: var(--jcBody);
  font-weight: 500;
  gap: var(--jc-spacer-small);
  line-height: 1;
  padding: var(--jc-spacer-small) var(--jc-spacer);
}

@media (max-width: 740px) {
  .badgeInfo {
    display: none;
  }
}

.premiumFeatureUsageLinkText {
  color: var(--jcGrey800);
  cursor: pointer;
  text-decoration: underline;
}

.premiumFeatureUsageLinkText:hover {
  color: var(--jcGrey800);
}

.infoIcon {
  color: var(--jc-text-color-dark-strong);
}
</style>
